import axios from '../../plugins/axios';

export const getBusinessFolder = ({ commit }, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }

  return axios.get(`/api/business/${data.businessId}/folder/${data.folderId}/year/${data.year}/month/${data.month}`, config)
    .then((response) => {
      const businessFolder = response.data
      commit('SET_BUSINESS_FOLDER', { businessFolder })
      return response
    })
    .catch((error) => error.response );
};

export const listBusinessFolder = ({ commit }, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }

  return axios.get(`/api/business/${data.businessId}/folder/year/${data.year}/month/${data.month}`, config)
    .then((response) => {
      const businessFolders = response.data
      commit('SET_BUSINESS_FOLDERS', { businessFolders })
      return response
    })
    .catch((error) => error.response );
}

export const createBusinessFolderFile = ({}, { data, businessFolderId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }

  return axios.post(`/api/business-folder/${businessFolderId}/file`,data, config)
    .then((response) => response)
    .catch((error) => error.response);
}

export const deleteBusinessFolderFile = ({}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }

  return axios.delete(`/api/business-folder/file/${id}`, config)
    .then((response) => response)
    .catch((error) => error.response);
}
